import { render } from "./FixedCostEdit.vue?vue&type=template&id=3ed0a530"
import script from "./FixedCostEdit.vue?vue&type=script&lang=js"
export * from "./FixedCostEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__